import React, {Component} from 'react';
import './App.css';
import QuoteGen from './components/QuoteGen.jsx'
import {QUOTES} from "./components/quotes.js"
import {BACKGROUNDS} from './components/backgrounds.js'


  
export default class App extends Component {
  constructor (props){
    super(props);
    this.state = {
      counter: 0,
      height: "400px",
      currentQuote:"",
      author:""
    }
    this.handleClick = this.handleClick.bind(this);
  }
    handleClick(){
      
      if (this.state.counter === QUOTES.length)  {
        this.setState({
                       counter:1,
                       height: calcHeight(QUOTES[0].text),
                       currentQuote: QUOTES[0].text,
                       author: QUOTES[0].author
                      });
      
      }
      else {
        this.setState(state => ({
                                 counter: state.counter+1,
                                 height: calcHeight(QUOTES[this.state.counter].text),
                                 currentQuote: QUOTES[this.state.counter].text,
                                 author: QUOTES[this.state.counter].author   
                                })
                              )
            }
           
  }
  

    render(){
             document.body.style.background = BACKGROUNDS[this.state.counter]; 
             return  (
                      <div className="App">
                          <QuoteGen counter={this.state.counter} colors={BACKGROUNDS}  height={this.state.height} currentQuote={this.state.currentQuote} author={this.state.author} click={this.handleClick}/>
                          <div class="signature">By KaiserP</div>
                      </div>
                     );
     }
  
}

function calcHeight(str){
        return window.innerWidth > 700 ? str.length*5 : str.length*3;
 }

